import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Supabase URL and Anon Key must be defined in environment variables");
}

/** Plazo de las lecturas/escrituras REST y de auth. */
const REQUEST_TIMEOUT_MS = 20_000;

/** Subidas de archivos y funciones (IA) pueden tardar más: sin plazo global. */
const UNBOUNDED_PATHS = ['/storage/v1/', '/functions/v1/'];

/**
 * Un backend colgado (no caído) deja el `fetch` pendiente para siempre y las
 * consultas nunca llegan a su estado de error. El plazo lo convierte en un
 * rechazo normal que TanStack Query ya sabe mostrar y reintentar.
 */
function fetchWithTimeout(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
  if (UNBOUNDED_PATHS.some((path) => url.includes(path))) return fetch(input, init);

  const timeout = AbortSignal.timeout(REQUEST_TIMEOUT_MS);
  const callerSignal = init?.signal;
  let signal: AbortSignal = timeout;
  if (callerSignal) {
    if (typeof AbortSignal.any !== 'function') return fetch(input, init);
    signal = AbortSignal.any([callerSignal, timeout]);
  }
  return fetch(input, { ...init, signal });
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  global: { fetch: fetchWithTimeout },
});
